<script lang="ts">
  import FizzStyles from "@modern/components/shared/FizzStyles.svelte";
  import DataInsightsActionBar from "./DataAndInsightsActionBar.svelte";
  import { onMount } from "svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import ResourceCard from "@shared/svelte/Components/ResourceCard.svelte";

  export let user;

  export function onClose() {
    HttpPromise({
      method: "POST",
      url: "api/user_notifications",
      data: {
        notification_type: "data_insights_action_bar",
        seen_at: new Date(Date.now() * 1000),
      },
    })
      .then(data => {
        user.has_seen_data_insights_action_bar = true;
      })
      .catch(res => {
        console.error(res);
      });
  }

  let resources = [
    {
      title: "Manage Biddable Campaigns and Reporting",
      text: "Engage retailers at the point of purchase on the Provi marketplace with targeted sponsored products, search and display ads opportunities. Be in control of budget spend and track the performance of your campaigns on Provi’s self-serve dashboard, powered by Instacart’s CarrotAds.",
      linkText: "Access your Provi CarrotAds Dashboard",
      link: "https://ads.instacart.com/login",
    },
    {
      title: "Alcohol Advertisements 101: How Display Ads Can Increase Sales & Awareness",
      text: "Learn more about what biddable ads are, and what types of promotion options are available on Provi’s marketplace. There are two ways to BUY ads to promote your products on Provi: fixed and biddable. This article will explain everything you need to know regarding fixed and biddable ads.",
      linkText: "Read More",
      link: "https://www.provi.com/brandpub/biddable-ads-101-an-introduction-to-promoting-on-provi",
    },
    {
      title: "The Brand Pub, Powered by Provi",
      text: "Read more articles on a blog built for suppliers and producers. The Brand Pub is a place to learn about promoting your brand, reaching new buyers, and building brand loyalty in the trade with strategic ecommerce solutions on the largest online marketplace for the beverage alcohol industry.",
      linkText: "Explore The Brand Pub",
      link: "https://www.provi.com/brandpub",
    },
    {
      title: "Provi Pulse Report: Uncovering the Top Beverage Alcohol Trends By Regions & Markets",
      text: "Across the drinks industry, shifts in consumer demand are in constant flux. This report aims to provide insights into the B2B beverage alcohol marketplace, analyzing trends across beer, wine and spirits across select regions and markets in the United States.",
      linkText: "Download The Report",
      link: "https://www.provi.com/resources/provi-pulse-beverage-alcohol-trend-report-q1-2023",
    },
    {
      title: "Subscribe to Provi Pulse",
      text: "Numbers matter when it comes to sales, and each Provi Pulse report provides industry insiders a unique look at the latest data and trends surrounding the beer, wine and spirits landscape. Get insights delivered to your inbox by signing up for Provi Pulse today!",
      linkText: "Subscribe to Provi Pulse",
      link: "https://www.provi.com/resources/subscribe-to-provi-pulse",
    },
    {
      title: "Looking for something else?",
      text: "Questions? Access additional help resources or speak to support at brands@provi.com",
      linkText: "Help Desk",
      link: "https://support.provi.com/s/topic/0TODn000000YIO7OAO/brands",
    },
  ];
</script>

<style>
  .fizz-inset-vertical-32 {
    padding: 32px 0;
  }
</style>

<FizzStyles>
  <div class="fizz-container fizz-inset-vertical-32">
    {#if user.has_seen_data_insights_action_bar == false}
      <DataInsightsActionBar {onClose} />
    {/if}
    <div class="fizz-styles">
      <section class="fizz-surface breadcrumb-links fizz-inset-32">
        <h3 class="fizz-heading-3 fizz-stack-4">Resources &amp; Links</h3>
        <p class="fizz-stack-24 fizz-text-medium">
          Check out resources to navigate data & insights, read Provi’s take on industry trends, and
          manage your ads.
        </p>

        <div class="fizz-grid fizz-stack-32" style="--grid-col-min: 343px; --grid-col-max: 416px">
          {#each resources as resource}
            <ResourceCard
              title={resource.title}
              text={resource.text}
              linkText={resource.linkText}
              link={resource.link}
            />
          {/each}
        </div>
      </section>
    </div>
  </div>
</FizzStyles>
